import PropTypes from 'prop-types'

import styles from './style.module.scss'
import tableItemStyles from '@assets/scss/components/table-item.module.scss'
import CustomLink from '../customLink'
import { Row } from 'react-bootstrap'
import MyImage from '../myImage'
import playerImg from '@assets/images/placeholder/player-placeholder.jpg'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@shared-submodule/sm-constants'
import { useRouter } from 'next/router'

const iccRankingsCard = ({ dataSSR, data, cardtitle, queryType }) => {
  const router = useRouter()
  // const baseUrl = new URL(router.asPath).origin;
  const baseUrl = router.asPath.split('?')[0]

  return (
    <>
      <div className={`${styles.rankingTab} widget`}>
        <div className={styles.tabContainer}>
          <div className={`${styles.cardDiv} position-relative`}>

            <div className={`${styles.cardTitle}`}>
              <h1 className=" my-2 d-flex justify-content-end">{cardtitle}</h1>
            </div>

            <div className={styles.imgContainer}>
              <div className={styles.flag}>
                <div className={`${styles.playerPic} overflow-hidden rounded-circle`}>
                  {(router?.query?.rank) ? (
                    <>
                      <MyImage src={data[0]?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${data[0]?.oPlayer?.oImg?.sUrl}` : playerImg} alt="user" blurDataURL={BLUR_DATA_URL_BASE64} placeholder="blur" layout="responsive" width="40" height="40" />
                    </>
                  ) : (
                    <>
                      <MyImage src={data[0]?.oTeams?.oImg?.sUrl ? `${S3_PREFIX}${data[0]?.oTeams?.oImg?.sUrl}` : playerImg} alt="user" blurDataURL={BLUR_DATA_URL_BASE64} placeholder="blur" layout="responsive" width="40" height="40" />

                    </>
                  )}
                </div>
                {(router?.query?.rank) && (
                  <div className={styles.teamCard}>
                    {data[0]?.sTeam}
                  </div>
                )}
              </div>
            </div>

            <div className={`${styles.titleDiv} d-flex`}>
              <Row className=' w-100'>
                <div className='col-3'>
                </div>
                <div className='col-6 pl-0'>
                  <p className={`${styles.titleName} mb-0  h-100 d-flex align-items-center`}>{data[0]?.oPlayer?.sName}{data[0]?.sName}
                    {/* <br/>
                {data[0]?.sName} */}
                  </p>
                </div>
                <div className='col-3 text-end p-0'>
                  <p className={`${styles.titleName} ${styles.titleRankH} mb-0`}>RATING<br /><p className={`${styles.titleRank} mb-0`}>
                    {data[0]?.nRating}</p>
                  </p>
                </div>

              </Row>
            </div>
          </div>
          <div className={tableItemStyles.itemCard}>
            <div className={`${tableItemStyles.item} ${tableItemStyles.head} ${styles.tHead} d-flex align-items-center`}>
              <p className="mb-0">{'Rank'}</p>
              {(router?.query?.rank) ? (
                <>
                  <p className={`${tableItemStyles.itemDesc} ${styles.wTeam} mb-0 flex-grow-1`}>{'Name'}</p>
                </>
              ) : (
                <>
                  <p className="mb-0 flex-grow-1">{'Team'}</p>

                </>
              )}
              {(router?.query?.rank) && (
                <p className="mb-0 flex-grow-1">{'Team'}</p>)}
              <p className="mb-0">{'Rating'}</p>
            </div>
            {data?.length === 0 && (
              <div className={tableItemStyles.item}>
                <p className="mb-0 w-100">{'No Data Found'}</p>
              </div>
            )}
            {data?.map((element) => {
              return (
                <div key={element._id} className={`${tableItemStyles.item} ${styles.itemMargin} d-flex align-items-center `}>
                  <p className="mb-0 ">{element.nRank}.</p>
                  <div className={`${tableItemStyles.itemDesc} ${styles.wTeam} flex-grow-1`}>
                    <p className="mb-0">{
                      element?.oPlayer?.eTagStatus === 'a' && element?.oPlayer?.oSeo?.eStatus === 'a' && element?.oPlayer?.oSeo?.sSlug ? (
                        <CustomLink href={`/${element?.oPlayer?.oSeo?.sSlug}`}>{element.sName}</CustomLink>
                      ) : (
                        element.sName
                      )
                    }</p>
                  </div>
                  {(router?.query?.rank) && (
                    <p className="mb-0 flex-grow-1">{element.sTeam}</p>)}
                  <p className="mb-0 ">{element.nRating}</p>
                </div>
              )
            })}
            {/* {urlStat ? ( */}
            {(router.query.gender === 'women') ? (
              <div className={`${styles.fullLink} cs-item d-flex flex-row-reverse`}>
                <a href={`${baseUrl}/women?match=${queryType}${router.query.rank !== undefined ? `&rank=${router.query.rank}` : ''}`} className="overflow-hidden text-nowrap d-flex">View Full List &gt;
                  <div className={`${styles.iccContent}`}>
                    {/* <RightBracketArrow /> */}
                  </div>
                </a>
              </div>
            ) : (
              <div className={`${styles.fullLink} cs-item d-flex flex-row-reverse`}>
                <a href={`${baseUrl}/men?match=${queryType}${router.query.rank !== undefined ? `&rank=${router.query.rank}` : ''}`} className="overflow-hidden text-nowrap d-flex">View Full List &gt;
                  {/* <div className={`${styles.iccContent}`}>
                  <RightBracketArrow />
                </div> */}
                </a>
              </div>
            )}
            {/* ) : ('') */}
            {/* } */}
          </div>
        </div>
      </div>
    </>
  )
}

iccRankingsCard.propTypes = {
  dataSSR: PropTypes.object,
  data: PropTypes.object,
  queryType: PropTypes.string,
  cardtitle: PropTypes.string
}

export default iccRankingsCard
